import { favoritesRoutes } from '@/Favorites/favorites.routes';
const favoritesModule = {
    routes: favoritesRoutes
};
export default favoritesModule;
